import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Address, AddressCreate } from "@spare-cart/contracts/checkout";
import { apiClient } from "@core/api";
import { addressKeys } from "./addressKeys";

export const useCreateAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: AddressCreate) => apiClient.post<Address>("/addresses", body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: addressKeys.lists() });
    },
  });
};
